import SlsGrupoComercialClient from '@/api/Cadastros/Cliente/sls-grupo-comercial.client';

import { ErrorMessage } from '@/libs/Error';

export default class SLSGrupoComercialService {
  constructor() {
    this.client = new SlsGrupoComercialClient();
    this.error = new ErrorMessage();
  }

  async index(queries) {
    try {
      const { data } = await this.client.index(queries);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os grupo comercial');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.client.store(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao criar Grupo Comercial');
    }
  }

  async show(id) {
    try {
      const { data } = await this.client.show(id);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao buscar Grupo Comercial');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.client.update(data);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao atualizar Grupo Comercial');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.client.destroy(id);
      return response;
    } catch (error) {
      this.error.message(error, 'Erro ao deletar Grupo Comercial');
    }
  }
}
